module.exports = __webpack_public_path__ + "static/media/2.87f7fd71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/images/2.svg
// module id = 914
// module chunks = 0